import {
  EBreakpoints,
  GRAY_LIGHT_TYPE_5,
  PRIMARY_TEXT_COLOR,
} from '@theme/theme';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  linkWrapper: {
    backgroundColor: GRAY_LIGHT_TYPE_5,
    padding: '16px 0',
    textDecoration: 'none',
    [theme.breakpoints.up(EBreakpoints.desktop)]: {
      padding: '20px 0',
    },
  },
  container: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  text: {
    '&&': {
      color: PRIMARY_TEXT_COLOR,
    },
  },
  logo: {
    height: 16,
    marginBottom: 2,
  },
}));
